import { initTrainingResourcesSectionSlides } from "./training-section-resources/index.js";
import { initMasterClassesMap } from "./master-classes/index.js";
import { initBeforeAfterSlider } from "./before-after/index.js";

function initTrainingPageModules() {
    initTrainingResourcesSectionSlides();
    initMasterClassesMap();
    initBeforeAfterSlider();
}

window.onload = () => {
    initTrainingPageModules();
}